import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";

/**
 * Returns the default value for a conclusion_select field
 */
export function getConclusionSelectDefaultValue(): FieldValue {
  return "";
}
